export var allHeaderTab = {
  dashboard: "dashboard",
  annualView: "annualView",
  budgetPlanning: "budgetPlanning",
  // transactions:"transactions"
};

export const navTabs = [
  { id: allHeaderTab.dashboard, icon: "grid", label: "Dashboard" },
  { id: allHeaderTab.annualView, icon: "file-text", label: "Annual View" },
  {
    id: allHeaderTab.budgetPlanning,
    icon: "calendar",
    label: "Budget Planning",
  },
  // { id: allHeaderTab.transactions, icon: 'edit', label: 'Transactions' },
];

export const transactionSideTabs = [
  { id: "all", label: "All" },
  { id: "maped", label: "Mapped" },
  { id: "unMaped", label: "UnMapped" },
];
